export default "__VITE_ASSET__DB88CCJh__"